module.exports = __webpack_public_path__ + "static/media/bg1.2a2bfc6b.jpg";